import Model from 'ducker-model';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { formatDate } from '@fund/basic-lib/dist/lib/date';
import format from '../utils/detail-format';

const DATE_STAGE_MAP = {
  Z: '近1周',
  Y: '近1月',
  '3Y': '近3月',
  '6Y': '近6月',
  '1N': '近1年',
  '2N': '近2年',
  '3N': '近3年',
  '5N': '近5年',
  JN: '今年来',
  LN: '成立来',
};

// 阶段涨幅
const StageProperty = {
  date: String, // 日期
  rise: String, // 收益率
  average: String,
  level: String,
  rank: String,
  sc: String,
};

const StageReplacedKeyFromPropertyName = {
  date: {
    property: 'title',
    computed: (title) => DATE_STAGE_MAP[title] || '--',
  },
  rise: {
    property: 'syl',
    computed: (syl) => (isEmpty(syl) ? '--' : `${numeral(syl).format('0.00')}%`),
  },
  average: {
    property: 'avg',
    computed: (avg) => (isEmpty(avg) ? '--' : `${numeral(avg).format('0.00')}%`),
  },
  level: {
    property: ['rank', 'sc'],
    computed: (([rank, sc]) => {
      const descConfig = ['优秀', '良好', '一般', '不佳'];
      if (rank && sc) {
        if (parseFloat(rank) === 1) return '优秀';
        const index = Math.ceil((parseFloat(rank) * 4) / parseFloat(sc));
        if (index < 1 || index > 4 || Number.isNaN(index)) return '--';
        return `${descConfig[index - 1]}`;
      }
      return '--';
    }),
  },
  rank: {
    property: 'rank',
    computed: (rank) => (!isEmpty(rank) ? parseInt(rank, 10) : '--'),
  },
  sc: {
    property: 'sc',
    computed: (sc) => (!isEmpty(sc) ? parseInt(sc, 10) : '--'),
  },
  title: {
    property: 'title',
    computed: (title) => (!isEmpty(title) ? title : '--'),
  },
};

// 基金经理
const fundManagerProperty = {
  id: String, // 基金经理id
  name: String, // 基金经理姓名
  avatar: String, // 基金经理头像
  serviceDays: Number, // 任职天数
  serviceDate: String, // 任职日期
  workDays: Number, // 从业天数
  yearSyl: Number, // 年化回报
  serviceSyl: Number, // 任职回报
  investIdeas: String, // 投资理念
  isGoldBullManager: String, // 是否是金牛奖经理
};

const fundManagerReplaceProperty = {
  id: {
    property: 'MGRID',
    computed: (id) => (!isEmpty(id) ? id : '--'),
  },
  name: {
    property: 'SINFO.MGRNAME',
    computed: (name) => (!isEmpty(name) ? name : '--'),
  },
  avatar: {
    property: 'PINFO[0].NEWPHOTOURL',
    computed: (avatar) => (!isEmpty(avatar) ? avatar : 'https://j5.dfcfw.com/sc/image/202110/20211009013728.png'),
  },
  serviceDays: {
    property: 'SINFO.TOTALDAYS',
    computed: (days) => format.formatDays(days),
  },
  serviceDate: { // 任职日期
    property: 'SINFO.FEMPDATE',
    computed: (date) => (isEmpty(date) ? '--' : formatDate(new Date(date.replace(/-/g, '/')), 'yyyy-MM-dd')),
  },
  workDays: { // 从业天数
    property: 'PINFO[0].TOTALDAYS',
    computed: (days) => format.formatDays(days),
  },
  yearSyl: {
    property: 'PINFO[0].YIELDSE',
    defaultValue: '--',
    computed: (yields) => (isEmpty(yields) ? '--' : `${Number(yields).toFixed(2)}%`),
  },
  serviceSyl: {
    property: 'SINFO.PENAVGROWTH',
    defaultValue: '--',
    computed: (yields) => (isEmpty(yields) ? '--' : `${Number(yields).toFixed(2)}%`),
  },
  investIdeas: {
    property: 'PINFO[0].INVESTMENTIDEAR',
    computed: (investIdeas) => (!isEmpty(investIdeas) ? investIdeas : '--'),
  },
  isGoldBullManager: {
    property: 'PINFO[0].AWARDNAME',
    defaultValue: false,
    computed: (glodManager) => glodManager && glodManager - 0 === 100,
  },
};

export default {
  stageRiseModel: new Model(StageProperty, StageReplacedKeyFromPropertyName),
  fundManagerModel: new Model(fundManagerProperty, fundManagerReplaceProperty),
};
